import { render, staticRenderFns } from "./SyncData.vue?vue&type=template&id=36275074&scoped=true&"
import script from "./SyncData.vue?vue&type=script&lang=js&"
export * from "./SyncData.vue?vue&type=script&lang=js&"
import style0 from "./SyncData.vue?vue&type=style&index=0&id=36275074&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36275074",
  null
  
)

export default component.exports